import { post } from "../network/index.js";
// 频道
// 获取频道列表
const queryChannellList = (data) => {
  return post("/mercWebi/attachment/channalList", data);
};

// 翡翠宫接口-未使用
// // 更新频道
// const updateChannell = (data) => {
//   return post("/webi/channal/update", data);
// };
// // 添加频道
// const addChannell = (data) => {
//   return post("/webi/channal/add", data);
// };
// // 删除频道
// const delChannell = (data) => {
//   return post("/webi/channal/delete", data);
// };
// // 频道排序
// const sortChannell = (data) => {
//   return post("/webi/channal/updateList", data, {
//     headers: { "Content-Type": "application/json" },
//   });
// };
export default {
  queryChannellList,
  // sortChannell,
  // updateChannell,
  // addChannell,
  // delChannell,
};
